import React from 'react';
import { LockIcon, ShieldCheckIcon } from 'lucide-react';
import { Section } from '../ui/Section';
import { Reveal } from '../ui/Reveal';
import { CountUp } from '../ui/CountUp';
import { CtaButton } from '../ui/CtaButton';
import { GuaranteeSeal } from '../ui/GuaranteeSeal';
import { guaranteeStats } from '../../data/content';

// Copy provisto por el cliente: garantía de 60 días con prueba social cuantitativa.

export function RiskReversal() {
  return <Section className="bg-cream" aria-labelledby="garantia-titulo" data-id="element-301" data-mp="1s0m648sm1t6b">
      <div className="mx-auto max-w-3xl" data-id="element-302" data-mp="1n0rge8kkn9mu">
        <Reveal data-id="element-303" data-mp="1i8q97129g93o">
          <div className="flex flex-col items-center text-center" data-id="element-304" data-mp="1i884dg1j8mk5">
            <GuaranteeSeal className="h-28 w-28 sm:h-36 sm:w-36" data-id="element-305" data-mp="1i6nc5x2oxfpg" />
            <p className="mt-6 inline-flex items-center gap-2 rounded-full bg-forest px-4 py-1.5 text-[0.7rem] font-bold uppercase tracking-[0.12em] text-white" data-id="element-306" data-mp="1d8vj2zqb7njo">
              <ShieldCheckIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-307" data-mp="25xsow3dc3rvj" />
              Garantía blindada
            </p>
            <h2 id="garantia-titulo" className="mt-5 text-[1.75rem] font-extrabold leading-[1.12] tracking-tight text-forest sm:text-4xl" data-id="element-308" data-mp="1wfou32tl7924">
              Garantía de 60 días — apostamos a que funciona
            </h2>
          </div>
        </Reveal>

        <Reveal delay={0.06} data-id="element-309" data-mp="1rnnm3t3gc4hw">
          <p className="mt-8 text-center text-base font-semibold text-ink sm:text-lg" data-id="element-310" data-mp="1rmvqwjdro8s5">
            Mira estos números de nuestros usuarios reales:
          </p>
        </Reveal>

        <ul className="mt-6 grid gap-3 sm:grid-cols-3 sm:gap-4" data-id="element-311" data-mp="1hp7uzq4fcv8e">
          {guaranteeStats.map((stat, index) => <Reveal as="li" key={stat.label} delay={0.08 + index * 0.06} className="list-none" data-id="element-312" data-mp="13pyesqg7y14f" data-mpi={index}>
              <div className="flex h-full flex-col items-center rounded-2xl border-t-[3px] border-gold bg-white px-5 py-6 text-center shadow-card" data-id="element-313" data-mp="18ojdumjqiera">
                <p className="text-4xl font-extrabold tracking-tight text-gold" data-id="element-314" data-mp="2y491otd96l7k">
                  <CountUp value={stat.value} suffix="%" data-id="element-315" data-mp="331rfax27tolw" />
                </p>
                <p className="mt-2 text-sm font-semibold leading-snug text-forest" data-id="element-316" data-mp="31m6m8japm2ph">{stat.label}</p>
                <p className="mt-auto pt-2 text-xs font-medium uppercase tracking-[0.1em] text-muted" data-id="element-317" data-mp="2wm0z9gfdx4dq">
                  {stat.window}
                </p>
              </div>
            </Reveal>)}
        </ul>

        <Reveal delay={0.16} data-id="element-318" data-mp="2mp6497iblm47">
          <div className="mt-8 border-l-4 border-gold bg-white p-6 shadow-card sm:p-9" data-id="element-319" data-mp="2mpxnrjyn7te4">
            <p className="text-base leading-relaxed text-body sm:text-lg" data-id="element-320" data-mp="3katpqxd8mk0y">
              Sabemos estos números. Por eso podemos darte esta garantía sin miedo:
            </p>
            <p className="mt-5 text-lg font-bold leading-snug text-forest sm:text-xl" data-id="element-321" data-mp="3aljw3d2qwtaq">
              Compra hoy. Aplica durante 60 días. Si después de 21 días de aplicar de verdad no ves
              los cambios que promete el protocolo, tu dinero regresa completo.
            </p>
            <p className="mt-5 text-base leading-relaxed text-ink sm:text-lg" data-id="element-322" data-mp="26s1xyuvrqqp">
              No hay trampa. No hay letra chica.{' '}
              <strong className="font-bold" data-id="element-323" data-mp="aghbvvzrb7x6">Un botón. Tu reembolso en 48 horas. Fin.</strong>
            </p>
            <p className="mt-5 text-base leading-relaxed text-body sm:text-lg" data-id="element-324" data-mp="eh9maskd7iv1">
              ¿Por qué nos atrevemos? Porque el <strong className="font-bold text-forest" data-id="element-325" data-mp="jej8lzcgjeen">94%</strong>{' '}
              hace que sea casi imposible que <em data-id="element-326" data-mp="ocugw5n3tgur">no</em> veas cambios. Y queremos que tú seas ese
              94%.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.22} data-id="element-327" data-mp="xfdkwt2mlzil">
          <div className="mt-9 flex flex-col items-center" data-id="element-328" data-mp="xeka9h0jqpv6">
            <CtaButton href="#comprar" size="lg" data-id="element-329" data-mp="126c4q2mtpfql">
              Quiero Acceso + Garantía Inquebrantable
            </CtaButton>
            <p className="mt-4 text-center text-sm font-medium text-forest" data-id="element-330" data-mp="175oq0iy1qer2">
              Acceso inmediato + 60 días de prueba + reembolso automático
            </p>
            <p className="mt-3 flex items-center justify-center gap-2 text-xs text-muted" data-id="element-331" data-mp="1h3mcb0wci1h1">
              <LockIcon className="h-3.5 w-3.5 text-forest" aria-hidden="true" data-id="element-332" data-mp="1h18kd0wyp5dp" />
              Procesado por Hotmart. Seguridad certificada SSL 256-bit.
            </p>
          </div>
        </Reveal>
      </div>
    </Section>;
}